import { render, staticRenderFns } from "./BarAndLineChart.vue?vue&type=template&id=3fd5ab4c&scoped=true"
import script from "./BarAndLineChart.vue?vue&type=script&lang=js"
export * from "./BarAndLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5ab4c",
  null
  
)

export default component.exports